import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { firstUserErrorCode } from '@/graphql/errors';
import { UPDATE_PAYMENT_METHOD } from '@/graphql/mutations/billing';
import type { TransactionOutcome } from './use-start-checkout';

type UseUpdatePaymentMethodResult = { updatePaymentMethod: () => Promise<TransactionOutcome> };

export function useUpdatePaymentMethod(): UseUpdatePaymentMethodResult {
  const [mutate] = useMutation(UPDATE_PAYMENT_METHOD);

  const updatePaymentMethod = useCallback(async (): Promise<TransactionOutcome> => {
    const { data } = await mutate();
    const payload = data?.updatePaymentMethod;
    if (payload?.transactionId) return { transactionId: payload.transactionId, errorCode: null };
    return { transactionId: null, errorCode: firstUserErrorCode(payload?.userErrors) ?? 'UNKNOWN' };
  }, [mutate]);

  return { updatePaymentMethod };
}
